<script setup lang="ts">
    import { computed } from 'vue';
    import Dialog from 'primevue/dialog';
    import SPPButton from './controls/SPPButton.vue';
    import { isMobile } from '@/util/breakpoints';
    import { useOrderAction, useOrderQuery } from '../composables/order';
    import router from '@/router';
    import { Navigation } from '@/router/navigation';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const { orderCompletedDialogIsVisible } = useOrderQuery();
    const orderAction = useOrderAction();

    const dialogStyle = computed(() => {
        if (isMobile.value) {
            return {
                mask: { style: 'align-items: end;' },
                root: {
                    style: 'width: 100% !important; max-width: 640px !important; border: 0px; border-top-left-radius: 16px; border-top-right-radius: 16px;',
                },
                content: {
                    style: 'overflow: hidden; display: flex; flex-direction: column; border-top-left-radius: 16px; border-top-right-radius: 16px;',
                },
                footer: {
                    style: 'display: flex; justify-content: center;',
                },
            };
        }

        return {
            root: {
                style: 'width: 100% !important; max-width: 640px !important; border: 0px; ',
            },
            content: {
                style: 'overflow: hidden; display: flex; flex-direction: column; ',
            },
        };
    });

    async function backToOrderList(): Promise<void> {
        orderAction.hideOrderCompletedDialog();
        await router.push({
            name: Navigation.PurchaseOrderList,
        });
    }
</script>
<template>
    <Dialog
        v-model:visible="orderCompletedDialogIsVisible"
        modal
        :show-header="true"
        :header="t('SUPPLIERS.ORDER_COMPLETED.TITLE')"
        :block-scroll="true"
        :draggable="false"
        :pt="dialogStyle"
        @update:visible="orderAction.hideOrderCompletedDialog()"
    >
        {{ t('SUPPLIERS.ORDER_COMPLETED.DESCRIPTION') }}
        <template #footer>
            <SPPButton
                :label="t('SUPPLIERS.ORDER_COMPLETED.BACK_TO_ORDERS_BUTTON')"
                :class="{ 'full-width': isMobile }"
                @click="backToOrderList"
            ></SPPButton>
        </template>
    </Dialog>
</template>
